module.exports = __webpack_public_path__ + "static/media/frog(7).9f1e54e7.PNG";